var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.$t('modal.quiz.title'),"confirmText":_vm.$t('general.got-it')}},[_c('div',{staticClass:"p-4"},[_c('p',[_vm._v("\n\t\t\t"+_vm._s(_vm.$org
					? _vm.$t('modal.quiz.text-organization')
					: _vm.$t('modal.quiz.text-applicant'))+"\n\t\t")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":`/test_${_vm.$org ? 'arbeitgeber' : 'arbeitnehmer'}.gif`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }